import React, { useState, useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import axios from 'axios';
import "./Subscriptions.css";
import { TableContext } from '../context';
import SearchTest from './TestResultsComponents/SearchTest';
import TimeTest from "./TestResultsComponents/TimeTest";
import IPaceTable from "./TestResultsComponents/IPaceTable1";
import StatusPageTable from "./TestResultsComponents/StatusPageTable";
import Loader from './Loader';
import { toast } from 'react-toastify';
import { McTabBar } from "@maersk-global/mds-react-wrapper/components-core/mc-tab-bar";
import { McTab } from "@maersk-global/mds-react-wrapper/components-core/mc-tab";
import CiInfoDrawer from "./CiInfoDrawer";
import ChangeDetailsDrawer from "./ChangeDetailsDrawer";

const TestResults = () => {
  const { tokenFetched, getCurrentFormattedDateTime } = useContext(TableContext);
  const [iPaceTableData, setiPaceTableData] = useState([]);
  const [StatusPageTableData, setStatusPageTableData] = useState([]);
  const [search, setSearch] = useState('');
  const [selectedTime, setSelectedTime] = useState({
    start: new Date(new Date().setDate(new Date().getDate() - 7)),
    end: new Date()
  });
  const [loading, setLoading] = useState(false);
  const [activeTestTab, setActiveTestTab] = useState("iPace");

  const tabLabels = ["iPace", "StatusPage"];
  const location = useLocation();
  const [isdrawerOpen, setisdrawerOpen] = useState(false);
  const [drawerCi, setDrawerCi] = useState("");
  const [drawerCiCategory, setDrawerCiCategory] = useState("");
  const [drawerType, setDrawerType] = useState("change_details");
  const [drawerChange, setDrawerChange] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        if(activeTestTab === "iPace") {
          await getiPaceTableData();
        } else {
          await getStatusPageTableData();
        }
        // await Promise.all([getiPaceTableData(), getStatusPageTableData()]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if(tokenFetched){
      fetchData();
    }
  }, [search, selectedTime, tokenFetched]);

  const getStatusPageTableData = async () => {
    setLoading(true);
    try {
      const body = {
        start_time: getCurrentFormattedDateTime(selectedTime.start),
        end_time: getCurrentFormattedDateTime(selectedTime.end)
      };

      if (search !== '') {
        body.search_query = search;

        const allTestsWithAppnameResponse = await axios.post(
          `${process.env.REACT_APP_BACKEND_URI}/api/flux_status_page/getSearchedStatusPageTestDetails`,
          body,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("jwt_token"),
            }
          }
        );

        setStatusPageTableData([]);
        if (!allTestsWithAppnameResponse.data.message) {
          setStatusPageTableData(prevStatusPageTableData => [...prevStatusPageTableData, ...allTestsWithAppnameResponse.data]);
        }
        else {
          setStatusPageTableData([]);
          toast.error("No Status Page Results found for Search Query",
            {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light"
            });
        }
      } else {
        const allTestsResponse = await axios.post(
          `${process.env.REACT_APP_BACKEND_URI}/api/flux_status_page/getAllStatusPageTestDetails`,
          body,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("jwt_token"),
            }
          }
        );

        setStatusPageTableData([]);
        if (!allTestsResponse.data.message) {
          setStatusPageTableData(prevStatusPageTableData => [...prevStatusPageTableData, ...allTestsResponse.data]);
        } else {
          setStatusPageTableData([]);
          toast.error("No Status Page Results found",
            {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light"
            });
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const getiPaceTableData = async () => {
    setLoading(true);
    try {
      const body = {
        start_time: getCurrentFormattedDateTime(selectedTime.start),
        end_time: getCurrentFormattedDateTime(selectedTime.end)
      };

      if (search !== '') {
        body.search_query = search;

        const allTestsWithAppnameResponse = await axios.post(
          `${process.env.REACT_APP_BACKEND_URI}/api/flux_ipace/getSearchedIpaceTestDetails`,
          body,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("jwt_token"),
            }
          }
        );

        setiPaceTableData([]);
        if (!allTestsWithAppnameResponse.data.message) {
          setiPaceTableData(previPaceTableData => [...previPaceTableData, ...allTestsWithAppnameResponse.data]);
        }
        else {
          setiPaceTableData([]);
          toast.error("No iPace Test results found for Search Query",
            {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light"
            });
        }
      } else {
        const allTestsResponse = await axios.post(
          `${process.env.REACT_APP_BACKEND_URI}/api/flux_ipace/getAllIpaceTestDetails`,
          body,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("jwt_token"),
            }
          }
        );

        if (allTestsResponse.data.message) {
          setiPaceTableData([]);
          toast.error("No iPace Test results found",
            {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light"
            });
        } else {
          setiPaceTableData(allTestsResponse.data);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tab = queryParams.get("tab");
    if (tab) {
      setActiveTestTab(tab);
    }
  }, [location.search, setActiveTestTab]);

  const handleTabChange = (e) => {
    setLoading(true);
    console.log("Tab change event:", e);
    const tabIndex = e.detail;
    const newTabLabel = tabLabels[tabIndex];
    console.log("Tab changed to:", newTabLabel);
    setActiveTestTab(newTabLabel);
    if (newTabLabel === "iPace") {
      getiPaceTableData();
    } else {
      getStatusPageTableData();
    }
  };

  const getMainTabIndex = () => {
    if (activeTestTab === "iPace") return 0;
    if (activeTestTab === "StatusPage") return 1;
    return 0; // default to first tab
  };

  return (
    <>
      {/* {loading && <Loader />} */}
      {isdrawerOpen && (
        drawerType === "ci_info" ? (
          <CiInfoDrawer
            isdrawerOpen={isdrawerOpen}
            setisdrawerOpen={setisdrawerOpen}
            drawerCi={drawerCi}
            drawerCiCategory={drawerCiCategory}
          />
        ) : drawerType === "change_details" && (
            <ChangeDetailsDrawer
              isdrawerOpen={isdrawerOpen}
              setisdrawerOpen={setisdrawerOpen}
              drawerCi={drawerCi}
              drawerCiCategory={drawerCiCategory}
              drawerChange={drawerChange}
            />
          )
      )}
      <div className='home'>
        {/* <h2 style={{ padding: '1.2rem 2.5rem 0rem', fontWeight: '500', fontSize: '1.5rem' }}>Search For Applications/Changes</h2> */}
        <div className='search' style={{ display: 'flex', justifyContent: 'space-between', margin: '30px 40px 45px' }}>
          <SearchTest setSearch={setSearch} />
          <TimeTest setSelectedTime={setSelectedTime} setLoading={setLoading} />
        </div>
        <div style={{ margin: "0 40px" }}>
          <McTabBar tabchange={handleTabChange} currentindex={getMainTabIndex()}>
            <McTab slot="tab" label="iPace Test Results" active={activeTestTab === "iPace"}></McTab>
            <div slot="panel">
              {
                <IPaceTable
                  Header1="Change Number"
                  Header2="Category"
                  Header3="Configuartion Item"
                  Header4="Planned Start Date"
                  Header5="Planned End Date"
                  Header6="Short Description"
                  Header7="Risk Impact"
                  Header8="Business Outcome"
                  Header9="Test Status"
                  Header10="Test URL"
                  tableData={iPaceTableData}
                  setisdrawerOpen={setisdrawerOpen}
                  setDrawerCi={setDrawerCi}
                  setDrawerCiCategory={setDrawerCiCategory}
                  setDrawerType={setDrawerType}
                  setDrawerChange={setDrawerChange}
                  isLoading={loading}
                />
              }
            </div>
            <McTab slot="tab" label="Status Page Test Results" active={activeTestTab === "StatusPage"}></McTab>
            <div slot="panel">
              {
                <StatusPageTable
                  Header1="Change Number"
                  Header2="Category"
                  Header3="Application Name"
                  Header4="Planned Start Date"
                  Header5="Planned End Date"
                  Header6="Short Description"
                  Header7="Risk Impact"
                  Header8="Prechange Test Status"
                  Header9="Prechange Failure Endpoints"
                  Header10="Postchange Test Status"
                  Header11="Postchange Failure Endpoints"
                  tableData={StatusPageTableData}
                  setisdrawerOpen={setisdrawerOpen}
                  setDrawerCi={setDrawerCi}
                  setDrawerCiCategory={setDrawerCiCategory}
                  setDrawerType={setDrawerType}
                  setDrawerChange={setDrawerChange}
                  isLoading={loading}
                />
              }
            </div>
          </McTabBar>
        </div>
      </div>
    </>
  );
};

export default TestResults;